import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAdvertCardContext } from '#advert/components/card';
import advertCardFooterCss from '../assets/advert-card-footer.module.scss';

const FooterAge: FC = () => {
  const { advert } = useAdvertCardContext();

  if (!advert.age) {
    return null;
  }

  return (
    <div className={advertCardFooterCss.advertCardFooter__age}>
      <div>
        <FormattedMessage defaultMessage="Age:" />
      </div>
      {advert.age}
    </div>
  );
};

export { FooterAge };
